/**
 * ==========================================================
 * Wholesale Enquiry Drawer
 * ==========================================================
 */

(() => {
  "use strict";

  const drawer = document.getElementById("WholesaleEnquiryDrawer");

  if (!drawer) return;

  const overlay = drawer.querySelector(".wholesale-drawer__overlay");
  const panel = drawer.querySelector(".wholesale-drawer__content");
  const closeBtn = drawer.querySelector(".wholesale-drawer__close");

  const hiddenProductInput = document.getElementById("WholesaleProduct");

  // Trigger Input
  const productSearch = document.getElementById("WholesaleProductSearch");

  // Search Input inside dropdown
  const productFilter = document.getElementById("WholesaleProductFilter");

  // Dropdown
  const productDropdown = document.getElementById(
    "WholesaleProductDropdown"
  );

  // Product List
  const productList = document.getElementById(
    "WholesaleProductList"
  );

  /**
   * ==========================================
   * Hide Dropdown Initially
   * ==========================================
   */

  if (productDropdown) {
    productDropdown.style.display = "none";
  }

  /**
   * ==========================================
   * Update Selected Products
   * ==========================================
   */

  function updateSelectedProducts() {

    if (!hiddenProductInput) return;

    const selected = [];

    productList
      ?.querySelectorAll("input[type='checkbox']:checked")
      .forEach((checkbox) => {

        selected.push(checkbox.value);

      });

    hiddenProductInput.value = selected.join(", ");

    if (productSearch) {

      if (selected.length === 0) {

        productSearch.value = "";

        productSearch.placeholder = "Select one or more products";

      } else {

        const maxVisible = 2;

        const visible = selected
          .slice(0, maxVisible)
          .map(title => title.length > 18 ? title.substring(0, 18) + ".. " : title);

        productSearch.value =
          selected.length > maxVisible
            ? `${visible.join(", ")} +${selected.length - maxVisible} more`
            : visible.join(", ");

      }

    }

  }

  /**
   * ==========================================
   * Open Product Dropdown
   * ==========================================
   */

  function openProductDropdown() {

    if (!productDropdown) return;

    productDropdown.style.display = "block";

    if (productFilter) {

      setTimeout(() => {

        productFilter.focus();

      }, 100);

    }

  }

  /**
   * ==========================================
   * Close Product Dropdown
   * ==========================================
   */

  function closeProductDropdown() {

    if (!productDropdown) return;

    productDropdown.style.display = "none";

    if (!productFilter) return;

    productFilter.value = "";

    productList
      ?.querySelectorAll(".wholesale-product-item")
      .forEach((item) => {

        item.style.display = "flex";

      });

  }

  /**
   * ==========================================
   * Toggle Dropdown
   * ==========================================
   */

  if (productSearch) {

    productSearch.addEventListener("click", function () {

      if (
        productDropdown.style.display === "block"
      ) {

        closeProductDropdown();

      } else {

        openProductDropdown();

      }

    });

  }

  /**
   * ==========================================
   * Product Search
   * ==========================================
   */

  if (productFilter && productList) {

    productFilter.addEventListener("input", function () {

      const keyword =
        this.value.trim().toLowerCase();

      productList
        .querySelectorAll(".wholesale-product-item")
        .forEach((item) => {

          const title =
            item.innerText.toLowerCase();

          item.style.display =
            title.includes(keyword)
              ? "flex"
              : "none";

        });

    });

  }

    /**
   * ==========================================
   * Product Checkbox Change
   * ==========================================
   */

  if (productList) {

    productList
      .querySelectorAll("input[type='checkbox']")
      .forEach((checkbox) => {

        checkbox.addEventListener("change", function () {

          updateSelectedProducts();

        });

      });

  }

  /**
   * ==========================================
   * Open Drawer
   * ==========================================
   */

  function openDrawer(product = "") {

    /**
     * Reset Previous Selection
     */

    if (productList) {

      productList
        .querySelectorAll("input[type='checkbox']")
        .forEach((checkbox) => {

          checkbox.checked = false;

        });

    }

    /**
     * Auto Select Product
     */

    if (product && productList) {

      productList
        .querySelectorAll("input[type='checkbox']")
        .forEach((checkbox) => {

          if (
            checkbox.value.trim().toLowerCase() ===
            product.trim().toLowerCase()
          ) {

            checkbox.checked = true;

          }

        });

    }

    updateSelectedProducts();

    /**
     * Close Product Dropdown
     */

    closeProductDropdown();

    /**
     * Open Drawer
     */

    drawer.classList.add("active");
    drawer.setAttribute("aria-hidden", "false");

    document.body.classList.add(
      "wholesale-drawer-open"
    );

    document.documentElement.style.overflow =
      "hidden";

    /**
     * Focus First Field
     */

    const firstInput = drawer.querySelector(
      "#WholesaleName"
    );

    if (firstInput) {

      setTimeout(() => {

        firstInput.focus();

      }, 250);

    }

  }

  /**
   * ==========================================
   * Close Drawer
   * ==========================================
   */

  function closeDrawer() {

    drawer.classList.remove("active");

    drawer.setAttribute(
      "aria-hidden",
      "true"
    );

    document.body.classList.remove(
      "wholesale-drawer-open"
    );

    document.documentElement.style.overflow =
      "";

    closeProductDropdown();

  }

  /**
   * ==========================================
   * Open From Button
   * ==========================================
   */

  document.addEventListener(
    "click",
    function (event) {

      const btn =
        event.target.closest(
          ".wholesale-open-popup"
        );

      if (!btn) return;

      event.preventDefault();

      openDrawer(
        btn.dataset.product || ""
      );

    }
  );

  /**
   * ==========================================
   * Close Button
   * ==========================================
   */

  if (closeBtn) {

    closeBtn.addEventListener(
      "click",
      closeDrawer
    );

  }

  /**
   * ==========================================
   * Overlay Click
   * ==========================================
   */

  if (overlay) {

    overlay.addEventListener(
      "click",
      closeDrawer
    );

  }

  /**
   * ==========================================
   * Prevent Closing
   * ==========================================
   */

  if (panel) {

    panel.addEventListener(
      "click",
      function (event) {

        event.stopPropagation();

      }
    );

  }

    /**
   * ==========================================
   * ESC Key
   * ==========================================
   */

  document.addEventListener("keydown", function (event) {

    // Close Product Dropdown
    if (
      event.key === "Escape" &&
      productDropdown &&
      productDropdown.style.display === "block"
    ) {

      closeProductDropdown();
      return;

    }

    // Close Drawer
    if (
      event.key === "Escape" &&
      drawer.classList.contains("active")
    ) {

      closeDrawer();

    }

  });

  /**
   * ==========================================
   * Close Product Dropdown on Outside Click
   * ==========================================
   */

/**
 * ==========================================
 * Close Dropdown When Clicking Anywhere
 * Inside the Form
 * ==========================================
 */

const form = document.getElementById("WholesaleContactForm");

if (form) {

  form.addEventListener("click", function (event) {

    if (
      !event.target.closest("#WholesaleProductSearch") &&
      !event.target.closest("#WholesaleProductDropdown")
    ) {

      closeProductDropdown();

    }
  });

}

const formHeader = document.querySelector('.wholesale-drawer__header');

// Listen for the click event
formHeader.addEventListener('click', (event) => {
    closeProductDropdown();
});


const wholesaleDrawerInner = document.querySelector("#wholesale-drawer-inner");

wholesaleDrawerInner.addEventListener("click", (event) => {
  // Ignore clicks on form fields
  if (
    event.target.closest(
      "input, textarea, select, button, label, [contenteditable='true']"
    )
  ) {
    return;
  }
  closeProductDropdown();
});

const wholesalePageFormMain = document.querySelector('.wholesale-page-form-main');

// Listen for the click event
wholesalePageFormMain.addEventListener('click', (event) => {
    if (
      event.target.closest(
        "input, textarea, select, button, label, [contenteditable='true']"
      )
    ) {
      return;
    }
    closeProductDropdown();
});



  /**
   * ==========================================
   * Global API
   * ==========================================
   */

  window.WholesaleEnquiry = {

    open(options = {}) {

      openDrawer(options.product || "");

    },

    close() {

      closeDrawer();

    }

  };

  /**
   * ==========================================
   * Auto Reopen After Form Submit
   * ==========================================
   */

  const success = drawer.querySelector(".wholesale-success");
  const errors = drawer.querySelector(".wholesale-errors");

  if (success || errors) {

    drawer.classList.add("active");
    drawer.setAttribute("aria-hidden", "false");

    document.body.classList.add("wholesale-drawer-open");
    document.documentElement.style.overflow = "hidden";

  }

})();